import client from './apiConnector';

async function get(override = null) {
  return client().get('/configs', { headers: override ? { 'RC-ACCOUNT': override } : {} });
}
async function edit(id, params) {
  return client().put(`/configs/${id}`, params);
}
async function create(params, override = null) {
  return client().post('/configs', params, { headers: override ? { 'RC-ACCOUNT': override } : {} });
}
async function createPreview(id, params) {
  return client().post(`/configs/${id}/preview`, params);
}
async function getById(id) {
  return client().get(`/configs/${id}`);
}
async function deleteById(id) {
  return client().delete(`/configs/${id}`);
}

export default {
  get,
  edit,
  create,
  createPreview,
  getById,
  deleteById,
};
